import { AIFunction } from '@/utils/const';
import { t } from '@/utils/helper/intl';

import { getBasePromptConfig } from './common';
import { ModelIdEnum } from './constants';

export const textToVideoModelConfig = [
  {
    modelName: 'Kling v3.0 Pro',
    modelValue: ModelIdEnum.TEXT_TO_VIDEO_Kling_v3_0_Pro,
    iconUrl: '/images/kling2.6pro.png',
    proOnly: true,
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Video),
      {
        type: 'AspectRatio',
        value: '1:1',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
      {
        type: 'durationSlider',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          min: 3,
          max: 15,
          step: 1,
          unit: 's',
        },
      },
      {
        type: 'switch',
        label: '359830b6b443f2a3fae314a287685809',
        key: 'sound',
        value: true,
        credit: true,
      },
    ],
  },
  {
    modelName: 'Kling v2.6 Pro',
    modelValue: ModelIdEnum.TEXT_TO_VIDEO_Kling_v2_6_Pro,
    iconUrl: '/images/kling2.6pro.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Video),
      {
        type: 'AspectRatio',
        value: '1:1',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
      {
        type: 'radio',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '5s', value: 5 },
            { label: '10s', value: 10 },
          ],
        },
      },
      {
        type: 'switch',
        label: '359830b6b443f2a3fae314a287685809',
        key: 'sound',
        value: true,
        credit: true,
      },
    ],
  },
  {
    modelName: 'Seedance v1.5 Pro',
    modelValue: ModelIdEnum.TEXT_TO_VIDEO_Seedance_v1_5_Pro,
    iconUrl: '/images/seedance1.5pro.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Video),
      {
        type: 'AspectRatio',
        value: '16:9',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '21:9', value: '21:9' },
            { label: '16:9', value: '16:9' },
            { label: '4:3', value: '4:3' },
            { label: '1:1', value: '1:1' },
            { label: '3:4', value: '3:4' },
            { label: '9:16', value: '9:16' },
          ],
        },
      },
      {
        type: 'durationSlider',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          min: 4,
          max: 12,
          step: 1,
          unit: 's',
        },
      },
      {
        type: 'radio',
        value: '720p',
        label: 'merror.export.resolution',
        key: 'resolution',
        credit: true,
        config: {
          options: [
            { label: '720p', value: '720p' },
            { label: '480p', value: '480p' },
          ],
        },
      },
      {
        type: 'checkbox',
        label: 'merror.0.8.lipsync.generatorAudio',
        key: 'generate_audio',
        value: true,
        credit: true,
        advanced: true,
        config: {
          label: t('fc.33302773'),
        },
      },
      {
        type: 'checkbox',
        label: 'fc.8d436b83',
        key: 'camera_fixed',
        value: false,
        advanced: true,
        config: {
          label: t('fc.b16ac978'),
        },
      },
    ],
  },
  {
    modelName: 'Sora 2 Pro',
    modelValue: ModelIdEnum.TEXT_TO_VIDEO_Sora_2_Pro,
    iconUrl: '/images/sora2.png',
    proOnly: true,
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Video),
      {
        type: 'radio',
        value: 4,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '4s', value: 4 },
            { label: '8s', value: 8 },
            { label: '12s', value: 12 },
          ],
        },
      },
      {
        type: 'radio',
        value: '720*1280',
        label: 'merror.export.resolution',
        key: 'size',
        credit: true,
        config: {
          options: [
            { label: '720*1280', value: '720*1280' },
            { label: '1280*720', value: '1280*720' },
            { label: '1024*1792', value: '1024*1792' },
            { label: '1792*1024', value: '1792*1024' },
          ],
        },
      },
    ],
  },
  {
    modelName: 'Veo 3.1',
    modelValue: ModelIdEnum.TEXT_TO_VIDEO_Veo_3_1,
    iconUrl: '/images/veo3.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Video),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
          ],
        },
      },
      {
        type: 'radio',
        value: 4,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '4s', value: 4 },
            { label: '6s', value: 6 },
            { label: '8s', value: 8 },
          ],
        },
      },
      {
        type: 'radio',
        value: '720p',
        label: 'merror.export.resolution',
        key: 'resolution',
        config: {
          options: [
            { label: '720p', value: '720p' },
            { label: '1080p', value: '1080p' },
          ],
        },
      },
      {
        type: 'switch',
        label: '359830b6b443f2a3fae314a287685809',
        key: 'generate_audio',
        value: false,
        credit: true,
      },
    ],
  },
  {
    modelName: 'Kling 2.5 Turbo Pro',
    modelValue: ModelIdEnum.TEXT_TO_VIDEO_Kling_2_5_Turbo_Pro,
    iconUrl: '/images/kling.png',
    formConfig: [
      getBasePromptConfig(AIFunction.Text2Video),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
      {
        type: 'radio',
        value: 5,
        label: 'merror.assets.duration',
        key: 'duration',
        credit: true,
        config: {
          options: [
            { label: '5s', value: 5 },
            { label: '10s', value: 10 },
          ],
        },
      },
    ],
  },
];
